module.exports = __webpack_public_path__ + "static/img/tb-calendar-check.d4cdbbcf.svg";